// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const ActionsheetSectionList = createStyle({
  w: '$full',
  h: 'auto',
});
